import { render, staticRenderFns } from "./SizeEdit.vue?vue&type=template&id=c58f7f68&scoped=true&"
import script from "./SizeEdit.vue?vue&type=script&lang=js&"
export * from "./SizeEdit.vue?vue&type=script&lang=js&"
import style0 from "./SizeEdit.vue?vue&type=style&index=0&id=c58f7f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58f7f68",
  null
  
)

export default component.exports